// extracted by mini-css-extract-plugin
export default {"text":"DescriptionInfo_text__LZ2Qm","textMobile":"DescriptionInfo_textMobile__yD5iF"};